var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22V18H20.5V22H0.5ZM4.5 14H5.9L13.7 6.225L12.275 4.8L4.5 12.6V14ZM2.5 16V11.75L13.7 0.575C13.8833 0.391667 14.0958 0.25 14.3375 0.15C14.5792 0.05 14.8333 0 15.1 0C15.3667 0 15.625 0.05 15.875 0.15C16.125 0.25 16.35 0.4 16.55 0.6L17.925 2C18.125 2.18333 18.2708 2.4 18.3625 2.65C18.4542 2.9 18.5 3.15833 18.5 3.425C18.5 3.675 18.4542 3.92083 18.3625 4.1625C18.2708 4.40417 18.125 4.625 17.925 4.825L6.75 16H2.5Z",
    fill: "#4D2481"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3f6a1b8b7f1eda7c06f97729c09216a2.svg";
export { ForwardRef as ReactComponent };